var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 20C13.8969 20 13.7939 19.9742 13.7027 19.9183C13.3064 19.6819 4 14.0416 4 8.20359C4 4.7816 6.56441 2.00016 9.71938 2.00016C11.3722 1.98726 12.9259 2.74818 14.004 4.06797C15.082 2.75678 16.6199 2.00016 18.2687 2.00016C18.2727 2.00016 18.2806 2.00016 18.2846 2.00016C21.4197 2.01736 23.9841 4.7988 24 8.19929C24 14.1233 14.6897 19.6862 14.2933 19.9183C14.2021 19.9742 14.0991 20 14 20Z",
    fill: "#E9E9F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/icon_favorite.70e8dece3bdbec7a67bcb474a811a89e.svg";
export { ForwardRef as ReactComponent };